/* Puurbystan · scrub-upsell (6 oktober 2026): voegt het sisal zakje toe zonder herladen en opent
   de melding "Artikel toegevoegd", net als product-form.js van Craft. Zonder deze code werkt de
   knop als gewone post naar de winkelwagen. */
if (!customElements.get('pbs-scrub')) {
  customElements.define('pbs-scrub', class PbsScrub extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.knop = this.querySelector('[type="submit"]');
      this.melding = document.querySelector('cart-notification');
      if (!this.form || !this.knop || !this.melding) return;
      if (this.form.querySelector('[name="return_to"]')) return;
      this.form.addEventListener('submit', this.verstuur.bind(this));
    }

    verstuur(evt) {
      evt.preventDefault();
      if (this.knop.getAttribute('aria-disabled') === 'true') return;
      const spinner = this.querySelector('.loading-overlay__spinner');
      this.knop.setAttribute('aria-disabled', 'true');
      this.knop.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
      this.melding.setActiveElement(document.activeElement);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const data = new FormData(this.form);
      data.append('sections', this.melding.getSectionsToRender().map((s) => s.id));
      data.append('sections_url', window.location.pathname);
      config.body = data;

      fetch(`${routes.cart_add_url}`, config)
        .then((r) => r.json())
        .then((r) => {
          if (r.status) {
            this.knop.removeAttribute('aria-disabled');
            return;
          }
          this.klaar();
          this.melding.renderContents(r);
        })
        .catch((e) => {
          console.error(e);
          this.knop.removeAttribute('aria-disabled');
        })
        .finally(() => {
          this.knop.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    klaar() {
      const span = this.knop.querySelector('span');
      if (span && this.knop.dataset.klaar) span.textContent = this.knop.dataset.klaar;
      this.knop.setAttribute('aria-disabled', 'true');
      this.classList.add('pbs-scrub--klaar');
    }
  });
}
